// extracted by mini-css-extract-plugin
export default {"vr":"Vr_vr__-n59c"};